import type { QueryClient } from "@tanstack/react-query";
import { keys } from "../../api/queries";
import type { StepSaveResponse, TenantResponse } from "../../api/types";

/**
 * Ein gespeicherter Schritt gehört auch in den Cache des Mandanten — sonst
 * zeigte der nächste Schritt des Wizards (oder ein anderer Reiter der
 * Detailseite) den Stand von vorher, bis die frische Antwort da ist.
 */
export function storeSavedStep(client: QueryClient, id: number, step: number, res: StepSaveResponse): void {
  client.setQueryData<TenantResponse>(keys.tenantDetail(id), (old) =>
    (old ? { ...old, tenant: res.tenant, checks: { ...old.checks, [String(step)]: res.check } } : old));
}

export const hasErrors = (check: { errors: Record<string, string> } | null | undefined): boolean => Object.keys(check?.errors ?? {}).length > 0;
